import { API, graphqlOperation } from "aws-amplify";
import { knowledgeGraphsByCustomerIdAndCreatedAt } from "../graphql/queries";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { KnowledgeGraphsByCustomerIdAndCreatedAtQuery } from "../API";

export async function fetchLLMKnowledgeGraphsByCustomerId(
  customerId: string
): Promise<GraphQLResult<KnowledgeGraphsByCustomerIdAndCreatedAtQuery>> {
  return API.graphql(
    graphqlOperation(knowledgeGraphsByCustomerIdAndCreatedAt, {
      customerId: customerId,
      sortDirection: "DESC", // Most recent first
    })
  ) as Promise<GraphQLResult<KnowledgeGraphsByCustomerIdAndCreatedAtQuery>>;
}
